/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { UseContentSource_ContentSourceFragmentDoc } from './useContentSource.graphql';
import { UseContentSource_DisplayFragmentDoc } from './useContentSource.graphql';
export type ChangeDefaultContentSourceModal_ContentSourceSettingsFragment = { __typename: 'ContentSourceSettings', available?: Array<{ __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null }> | null, current?: { __typename: 'ContentSourceState', desired?: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } | null, reported: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } } | null, default?: { __typename: 'ContentSourceState', desired?: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } | null, reported: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } } | null };

export type ChangeDefaultContentSourceModal_DisplayFragment = { __typename: 'Display', id: string, bookmarks: { __typename: 'Bookmarks', all: { __typename: 'AllBookmarksState', reported?: Array<string> | null, desired?: Array<string | null> | null } }, contentSource?: { __typename: 'ContentSourceSettings', default?: { __typename: 'ContentSourceState', desired?: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } | null, reported: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } } | null, available?: Array<{ __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null }> | null, current?: { __typename: 'ContentSourceState', reported: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null }, desired?: { __typename: 'AppContentSource', label?: string | null, applicationId: string, activityList?: Array<string> | null, selectedActivity?: string | null, isBootable?: boolean | null } | { __typename: 'BookmarkContentSource', index: number } | { __typename: 'InputContentSource', source: string } | { __typename: 'PlaylistContentSource', playlistId: string, title?: string | null } | null } | null } | null, playlist?: { __typename: 'DisplayPlaylist', current?: { __typename: 'DisplayCurrentPlaylist', id: string, title: string } | null } | null };

export const ChangeDefaultContentSourceModal_ContentSourceSettingsFragmentDoc = gql`
    fragment ChangeDefaultContentSourceModal_contentSourceSettings on ContentSourceSettings {
  available {
    ...UseContentSource_contentSource
  }
  current {
    desired {
      ...UseContentSource_contentSource
    }
    reported {
      ...UseContentSource_contentSource
    }
  }
  default {
    desired {
      ...UseContentSource_contentSource
    }
    reported {
      ...UseContentSource_contentSource
    }
  }
}
    ${UseContentSource_ContentSourceFragmentDoc}`;
export const ChangeDefaultContentSourceModal_DisplayFragmentDoc = gql`
    fragment ChangeDefaultContentSourceModal_display on Display {
  id
  ...UseContentSource_display
  bookmarks {
    all {
      reported
      desired
    }
  }
  contentSource {
    default {
      desired {
        ... on AppContentSource {
          label
          applicationId
        }
        ... on BookmarkContentSource {
          index
        }
        ... on InputContentSource {
          source
        }
        ... on PlaylistContentSource {
          playlistId
        }
      }
      reported {
        ... on AppContentSource {
          label
          applicationId
        }
        ... on BookmarkContentSource {
          index
        }
        ... on InputContentSource {
          source
        }
        ... on PlaylistContentSource {
          playlistId
        }
      }
    }
    available {
      ... on AppContentSource {
        label
        applicationId
      }
      ... on BookmarkContentSource {
        index
      }
      ... on InputContentSource {
        source
      }
      ... on PlaylistContentSource {
        playlistId
      }
    }
  }
  playlist {
    current {
      id
      title
    }
  }
}
    ${UseContentSource_DisplayFragmentDoc}`;